/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Notify_Target_Telegram_PhInputs */

const en_fw_notify_target_telegram_ph = /** @type {(inputs: Fw_Notify_Target_Telegram_PhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telegram chat id, e.g. 123456789`)
};

const id_fw_notify_target_telegram_ph = /** @type {(inputs: Fw_Notify_Target_Telegram_PhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat id Telegram, mis. 123456789`)
};

/**
* | output |
* | --- |
* | "Telegram chat id, e.g. 123456789" |
*
* @param {Fw_Notify_Target_Telegram_PhInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_notify_target_telegram_ph = /** @type {((inputs?: Fw_Notify_Target_Telegram_PhInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Notify_Target_Telegram_PhInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_notify_target_telegram_ph(inputs)
	return en_fw_notify_target_telegram_ph(inputs)
});